/**
 * QB Estimates hook — consolidated to use the primary Supabase project.
 * TODO: Decommission sandbox project (maltrtjtputdznaloovz) once validated in production.
 */
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface QBEstimate {
  id: string;
  quickbooks_id: string | null;
  doc_number: string | null;
  customer_qb_id: string | null;
  customer_ref_name: string | null;
  total_amount: number | null;
  txn_date: string | null;
  txn_status: string | null;
  status: string | null;
  line_items: unknown[] | null;
  created_at: string | null;
}

export function useQBEstimates() {
  return useQuery<QBEstimate[]>({
    queryKey: ["qb_estimates"],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from("qb_estimates")
        .select("*")
        .order("txn_date", { ascending: false });

      if (error) throw error;
      return (data ?? []) as unknown as QBEstimate[];
    },
  });
}
